import { Injectable } from '@angular/core';
import {ObjectService} from "./abstractions/objects/object.service.abstract";
import {
  IFunctionAssistantMediaHostAllowlistUpdateRequest,
  IFunctionAssistantMediaHostAllowlistUpdateResponse,
  IFunctionBearerCredentialUpdateRequest,
  IConfiguredFunctionManifest,
  IFunctionOptions,
  IFunctionPatchRequest,
  IFunctionTestRequest
} from "../../models/function-options.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FunctionsService extends ObjectService<IFunctionOptions> {

  protected api = '/functions/'; // Base URL for the client API

  createDraftAsync(name: string): Observable<IFunctionOptions> {
    return this.http.post<IFunctionOptions>(this.getEndpoint() + 'drafts', {name});
  }

  testFunctionAsync(id: string, payload: IFunctionTestRequest): Observable<unknown> {
    return this.http.post<unknown>(this.getEndpoint() + id + '/test', payload);
  }

  getManifestAsync(assistantId: string): Observable<IConfiguredFunctionManifest> {
    return this.http.get<IConfiguredFunctionManifest>(this.getEndpoint() + 'manifest/' + assistantId);
  }

  patchAsync(id: string, payload: IFunctionPatchRequest): Observable<IFunctionOptions> {
    return this.http.patch<IFunctionOptions>(this.getEndpoint() + id, payload);
  }

  patchAssistantMediaHostAllowlistAsync(
    id: string,
    payload: IFunctionAssistantMediaHostAllowlistUpdateRequest
  ): Observable<IFunctionAssistantMediaHostAllowlistUpdateResponse> {
    return this.http.patch<IFunctionAssistantMediaHostAllowlistUpdateResponse>(
      this.getEndpoint() + id + '/assistant-media-host-allowlist',
      payload
    );
  }

  patchBearerCredentialAsync(
    id: string,
    payload: IFunctionBearerCredentialUpdateRequest
  ): Observable<IFunctionOptions> {
    return this.http.patch<IFunctionOptions>(this.getEndpoint() + id + '/bearer-credential', payload);
  }

  deleteWithEtagAsync(id: string, etag: string): Observable<unknown> {
    return this.http.delete(this.getEndpoint() + id, {params: {etag}});
  }
}
